import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { delete_employee_attendance, get_all_filtered_attendance, update_employee_attendance } from '../../../../app/pages/Employees/attendance/api/attendanceApi';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { KTIcon, KTSVG } from '../../../helpers';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { formatDateOnly, formatDateWithTime, formatDateWithTime24h } from './../../../../app/helper-functions/DateFunction';
import { Attendance, AttendanceType, Shifts } from '../../../../app/modules/accounts/components/settings/SettingsModel';
import { add_attendance } from '../api/widgetApi';
type Props = {
  className: string;
  active_attendance_type: AttendanceType[];
  location_shift:Shifts[];
  refetch: () => void; // Include refetch in Props
};
type UpdateAttendanceParams = {
  id: number;
  user_id: number;
  shift_id: number;
  attendance_type_id: number;
  attendance_datetime: string;
  employee_attendance_notes:string;
};
function AttendanceListWidget({active_attendance_type,location_shift,employee_attendance_by_id,refetch}) {
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedShiftId, setSelectedShiftId] = useState('');
  const [visibleData, setVisibleData] = useState<Attendance[]>([]);
  const [attendanceList, setAttendanceList] = useState<Attendance[]>([]);
  const [ErrorAttendanceType, setErrorAttendanceType] = useState('');
  const [selectedNotes, setSelectedNotes] = useState('');
  const [ErrorNotes, setErrorNotes] = useState('');
  const [ErrorUserId, setErrorUserId] = useState('');
  const [ErrorShiftId, setErrorShiftId] = useState(''); 
  const [shiftsList, setShiftsList] = useState<Shifts[]>([]);
  const [selectedAttendance, setSelectedAttendance] = useState<Attendance | null>(null);
  const [attendanceTypeList, setAttendanceTypeList] = useState<AttendanceType[]>([]);
  const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(5); // Start with 5 items per page
  const [selectedUser, setSelectedUser] = useState('');
  const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null);
  const [selectedAttendanceType, setSelectedAttendanceType] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [selectedFromDate, setSelectedFromDate] = useState<string>("");
  const [selectedToDate, setSelectedToDate] = useState<string>("");
  const [showAll, setShowAll] = useState(false); // State to toggle between 5 and all records
  const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
  const [selectedAttendanceTypeAdd, setSelectedAttendanceTypeAdd] = useState('');
  const [filterPayload, setFilterPayload] = useState<any>({});
  const today = new Date().toISOString().slice(0, 10); // Get the current date in 'YYYY-MM-DD' format
  const [originalAttendanceList, setOriginalAttendanceList] = useState<Attendance[]>([]); // To store the original list
  const currentUser = localStorage.getItem('auth_user_id');
  const currentUserId = currentUser ? JSON.parse(currentUser) : null;
  useEffect(() => {
    if (location_shift) {
      setShiftsList(location_shift);
    }
  }, [location_shift]);

  useEffect(() => { 
    // Set today's date as the default value for 'From Date' and 'To Date'
    setSelectedFromDate(today);
    setSelectedToDate(today);
    // Check if attendanceData is not null or undefined and has data
    if (employee_attendance_by_id && employee_attendance_by_id && Object.keys(employee_attendance_by_id).length !== 0) {
      // Filter attendance records to show only today's attendance
      const filteredAttendance = employee_attendance_by_id.filter((attendance) => {
        // Extract date from attendance_datetime
        const attendanceDate = attendance.attendance_datetime.slice(0, 10);
        return attendanceDate === today;
      });
      // Set the filtered attendance list
      setAttendanceList(filteredAttendance);
      setOriginalAttendanceList(filteredAttendance); // Store filtered list as original
    } else {
      // Handle the case where there's no attendance data
      setAttendanceList([]); // Set an empty list or handle as needed
    }
    setSelectedEmployeeId(currentUserId);
  }, [employee_attendance_by_id,selectedEmployeeId]);

  useEffect(() => {
    if (active_attendance_type) {
      if (Array.isArray(active_attendance_type)) {
        setAttendanceTypeList(active_attendance_type as AttendanceType[]);
      } else {
        setAttendanceTypeList([]); // Fallback to an empty array
      }
    }
  }, [active_attendance_type]);  

  const itemsPerPageOptions = [5, 10, 20, 30, 50, 100]; // Added 5 as the first option
  const totalItems = attendanceList.length;
  const totalPages = Math.ceil(totalItems / selectedItemsPerPage);

  useEffect(() => {
    if (attendanceList.length > 0) {
      let sortedData = [...attendanceList];
      if (sortBy) {
        sortedData.sort((a, b) => {
          const aValue = (a[sortBy.key] || '') as string;
          const bValue = (b[sortBy.key] || '') as string;
          return sortBy.ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        });
      }
      setVisibleData(
        sortedData.slice(
          0,
          showAll ? sortedData.length : 5 // Show first 5 or all based on showAll state
        )
      );
    }
  }, [attendanceList, showAll, sortBy]);

  const toggleShowAll = () => {
    setShowAll(!showAll);
    if (!showAll) {
      setSelectedItemsPerPage(totalItems); // Show all items
    } else {
      setSelectedItemsPerPage(5); // Show only 5 items
    }
  };
  const user_id = authData.user?.id || null;
  const currDate = new Date();
  const mutation = useMutation(() => add_attendance(selectedShiftId, formatDateWithTime24h(currDate), selectedAttendanceTypeAdd,selectedNotes), {
    onSuccess: (response) => {
      toast.success(response.message, {
        position: 'top-right',
        autoClose: 3000,
      });
      refetch();
      setSelectedAttendanceTypeAdd("")
      setSelectedUserId("");
      setSelectedShiftId("");
      setSelectedNotes("");
    },
    onError: (error: any) => {
      if (error.response) {
        toast.error(error.response.data.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else if (error.request) {
        toast.error('No response received from the server.', {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    },
  });
  const handleInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.currentTarget.value.toLowerCase();
    setSearchInput(searchTerm);
    const filteredItems = employee_attendance_by_id.filter((attendance) => {
      return (
        attendance.user_name?.toLowerCase().includes(searchTerm) ||
        attendance.shift_name?.toLowerCase().includes(searchTerm) ||
        attendance.attendance_type_name?.toLowerCase().includes(searchTerm) 
      );
    });
    setAttendanceList(filteredItems);
  }, [originalAttendanceList,employee_attendance_by_id]);
  const { data: filterData, refetch: filterRefetch } = useQuery(
    ['filterData', filterPayload,{
        refetchOnWindowFocus: false,
      }],
    () => get_all_filtered_attendance(filterPayload),
    {
      onSuccess: (filteredData) => {
         setAttendanceList(filteredData.data);
      setOriginalAttendanceList(filteredData.data); //
      setVisibleData(filteredData.data)
      },
      onError: (error: any) => {
        if (error.response) {
          const errorMessage = error.response.data.message
          toast.error(errorMessage, {
            position: 'top-right',
            autoClose: 4000,
          });
        }
      },
      enabled: false,
    }
  );
  useEffect(() => {
    if (Object.keys(filterPayload).length > 0) {
        filterRefetch();
    }
}, [filterPayload]);
  const handleApplyFilters = () => {
    const payload: any = {};
if (selectedFromDate) {
  payload.date_flag = "specific";
  payload.from_date = selectedFromDate;
}
if (selectedToDate) {
    payload.date_flag = "specific";
    payload.to_date = selectedToDate;
  }
if (selectedEmployeeId) {
  payload.user_flag = "specific";
  payload.user_id = selectedEmployeeId;
}
if (selectedAttendanceType) {
    payload.attendance_type_flag = "specific";
    payload.attendance_type_id = selectedAttendanceType;
  }
setFilterPayload(payload);
};
const handleClearFilters = () => {
    setSelectedAttendanceType('');
    setSelectedFromDate("");
    setSelectedToDate("");
    setSelectedUser('');
    setFilterPayload({});  // Clear the filter payload
    if (employee_attendance_by_id) {
        // Filter attendance records to show only today's attendance
        const filteredAttendance = employee_attendance_by_id.filter((attendance) => {
            // Extract date from attendance_datetime
            const attendanceDate = attendance.attendance_datetime.slice(0, 10);
            return attendanceDate === today;
        });
        // Set the filtered attendance list
        setAttendanceList(filteredAttendance);
        setOriginalAttendanceList(filteredAttendance); // Store filtered list as original
    }
};
  const handleSort = (key: string) => {
    if (sortBy && sortBy.key === key) {
      setSortBy({ key, ascending: !sortBy.ascending });
    } else {
      setSortBy({ key, ascending: true });
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div className='card mb-5 mb-xl-10'>
    <div className='card-header border-0 pt-5'>
      <h3 className='card-title align-items-start flex-column'>
        <span className='card-label fw-bolder fs-3 mb-1'>My Attendance ({authData?.user?.full_name})</span>
      </h3>
    </div>
    
    <div className='card-header border-0 pt-5 row'>
      <div className='card-title col-lg-6'>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-3 position-absolute ms-5' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-13'
            placeholder='Search Attendance...'
            value={searchInput}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>

    <div className='card-header border-0 pt-5'>
      <div className='row g-6'>
           <div className='col-12'>
                    <h5 className='mb-2 fw-semibold text-gray-700'>Filter by:</h5>
                </div>
        <div className='col-md-4'>
          <div className='d-flex align-items-center'>
            <label className='form-label me-3 mb-0'>From:</label>
            <DatePicker
              className='form-control form-control-solid'
              placeholderText="Select From Date"
              selected={selectedFromDate}
              dateFormat='dd-MM-yyyy'
              onChange={(date) => setSelectedFromDate(formatDateOnly(date))}
            />
          </div>
        </div>
        <div className='col-md-4'>
          <div className='d-flex align-items-center'>
            <label className='form-label me-3 mb-0'>To:</label>
            <DatePicker
              className='form-control form-control-solid'
              placeholderText="Select To Date"
              selected={selectedToDate}
              dateFormat='dd-MM-yyyy'
              onChange={(date) => setSelectedToDate(formatDateOnly(date))}
            />
          </div>
        </div>
        <div className='col-md-4'>
          <select
            className='form-select form-select-solid'
            value={selectedAttendanceType}
            onChange={(e) => setSelectedAttendanceType(e.target.value)}
          >
            <option value=''>Filter by Attendance Type...</option>
            {Array.isArray(attendanceTypeList) && attendanceTypeList.length > 0 ? (
              attendanceTypeList.map((attendanceType) => (
                <option key={attendanceType.id} value={attendanceType.id}>
                  {attendanceType.title}
                </option>
              ))
            ) : (
              <option value='' disabled>No Attendance Type available</option>
            )}
          </select>
        </div>
      </div>
    </div>

    <div className='card-header border-0 mx-3 d-flex flex-column align-items-end'>
      <div className='btn-group'>
        <button
          className='btn btn-primary me-3'
          onClick={handleApplyFilters}
        >
          <KTIcon iconName='filter' className='fs-2' /> Apply Filters
        </button>
        <button
          className='btn btn-light-danger'
          onClick={handleClearFilters}
        >
          <KTIcon iconName='trash' className='fs-2' /> Clear Filters
        </button>
      </div>
    </div>
    <div className='card-body py-3'>
      <div className='table-responsive'>
        <table className='table table-row-bordered table-row-dashed gy-4 align-middle'>
          <thead className='fs-7 text-gray-400 bg-light'>
            <tr>
              <th className='min-w-150px' onClick={() => handleSort('attendance_type_name')}>
                Attendance Type <KTIcon iconName={sortBy?.key === 'attendance_type_name' ? (sortBy.ascending ? 'arrow-up' : 'arrow-down') : 'up-down'} className='fs-4 cursor-pointer' />
              </th>
              <th className='min-w-120px' onClick={() => handleSort('attendance_datetime')}>
                Time <KTIcon iconName={sortBy?.key === 'attendance_datetime' ? (sortBy.ascending ? 'arrow-up' : 'arrow-down') : 'up-down'} className='fs-4 cursor-pointer' />
              </th>
              <th className='min-w-120px' onClick={() => handleSort('shift_name')}>
                Shift <KTIcon iconName={sortBy?.key === 'shift_name' ? (sortBy.ascending ? 'arrow-up' : 'arrow-down') : 'up-down'} className='fs-4 cursor-pointer' />
              </th>
              <th className='min-w-120px' onClick={() => handleSort('updated_by_name')}>
                Updated By <KTIcon iconName={sortBy?.key === 'updated_by_name' ? (sortBy.ascending ? 'arrow-up' : 'arrow-down') : 'up-down'} className='fs-4 cursor-pointer' />
              </th>
            </tr>
          </thead>
          <tbody className='fs-6'>
            {Array.isArray(visibleData) && visibleData.length > 0 ? (
              visibleData.map((attendance: any) => (
                <tr key={attendance.id}>
                  <td>
                    <span className='text-dark fw-bold d-block fs-6'>
                      {attendance.attendance_type_name}
                    </span>
                  </td>
                  <td>
                    <span className='text-muted fw-semibold d-block fs-6'>
                      {formatDateWithTime(attendance.attendance_datetime)}
                    </span>
                  </td>
                  <td>
                    <span className='text-muted fw-semibold d-block fs-6'>
                      {attendance.shift_name}
                    </span>
                  </td>
                  <td>
                    <span className='text-muted fw-semibold d-block fs-6'>
                      {attendance.updated_by_name}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className='text-center py-10'>
                  <div className='d-flex flex-column align-items-center'>
                    <KTIcon iconName='information-5' className='fs-2x text-gray-400 mb-2' />
                    <span className='text-gray-600'>No attendance records found</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>

    <div className='card-footer d-flex justify-content-between align-items-center py-4'>
      <div className='d-flex align-items-center'>
        <select
          className='form-select form-select-sm form-select-solid w-75px me-3'
          value={selectedItemsPerPage}
          onChange={(e) => {
            setSelectedItemsPerPage(Number(e.target.value));
            setShowAll(Number(e.target.value) === totalItems);
          }}
        >
          {itemsPerPageOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
        <span className='text-muted'>Showing {showAll ? totalItems : Math.min(5, totalItems)} of {totalItems} records</span>
      </div>
      
      <div className='d-flex'>
        {!showAll && totalItems > 5 && (
          <button
            className='btn btn-sm btn-primary'
            onClick={toggleShowAll}
          >
            <KTIcon iconName='arrow-down' className='fs-2' /> View All
          </button>
        )}
        {showAll && totalItems > 5 && (
          <button
            className='btn btn-sm btn-light-primary'
            onClick={toggleShowAll}
          >
            <KTIcon iconName='arrow-up' className='fs-2' /> Show Less
          </button>
        )}
      </div>
    </div>

    {/* Modals remain the same */}
    {/* Delete Modal */}
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* ... existing delete modal code ... */}
    </div>
    
    {/* Add Employee Attendance Modal */}
    <div className='modal fade' tabIndex={-1} id='kt_modal_0'>
      {/* ... existing add modal code ... */}
    </div>
    
    {/* Edit Modal */}
    <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
      {/* ... existing edit modal code ... */}
    </div>
  </div>
)
}

export default AttendanceListWidget;